@if (product$ | async; as product) {
  <ul>
    @if (product.keySpecs?.length) {
      @for (spec of product.keySpecs; track spec) {
        <li>{{ spec }}</li>
      }
    } @else {
      <li>{{ 'keyFeatures.noContent' | cxTranslate }}</li>
    }
  </ul>
}
